"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n\n  /* Extra specificity to override the is--module class */\n  && {\n    ", ";\n  }\n\n  & > :last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ScrollWrapper = _styledComponents.default.div.withConfig({
  displayName: "UISection__ScrollWrapper",
  componentId: "rutf1z-0"
})(_templateObject(), function (props) {
  return (0, _Styles.toPx)(props.height);
}, function (props) {
  return props.flush && "margin-bottom: 0";
});

var UISection = _react.default.createClass({
  displayName: "UISection",
  propTypes: {
    children: _propTypes.default.node,
    flush: _propTypes.default.bool.isRequired,
    height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    use: _propTypes.default.oneOf(['default', 'island']).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      flush: false,
      overhang: false,
      overhangDirection: 'horizontal',
      use: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "use"]);
    return _react.default.createElement(ScrollWrapper, (0, _extends2.default)({}, rest, {
      className: (0, _classnames.default)(className, 'is--module', 'namespaced-hack-section', {
        'is--island': use === 'island'
      }),
      use: "use"
    }), children);
  }
});

var _default = UISection;
exports.default = _default;
module.exports = exports.default;